<template>
  <custom-dialog
    :show="show"
    :title="$t('account.edit_title')"
    @toggleShow="handleClose"
    width="400"
  >
    <div class="flex form" slot="main">
      <el-form
        :rules="rules"
        :validate-on-rule-change="false"
        ref="form"
        :model="form"
        label-width="100px"
        label-position="left"
      >
        <el-form-item
          :label="$t(item.label) + colon"
          v-for="item in currentFormItem"
          :key="item.key"
          :prop="item.key"
        >
          <el-input
            size="small"
            style="width: 250px"
            v-model="form[item.key]"
            :placeholder="$t(item.label)"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="flex btns" slot="footer">
      <el-button
        type="primary"
        class="btn"
        @click="handleSubmit"
        size="small"
      >
        {{ $t("public.save") }}
      </el-button>
      <el-button
        class="btn"
        size="small"
        @click="handleClose()"
      >
        {{ $t("public.cancel") }}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
import CustomDialog from "../../../components/public/customDialog";
import { updateProjectName } from "@/api/index";
export default {
  name: "ConfimePwd",
  components: {
    CustomDialog,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      formItem: [
        {
          label: "public.projectName",
          key: "projectName",
          inputType: "input",
        },
      ],
      form: {
        projectName: "",
      },
    };
  },
  computed: {
    // 英文标签用半角冒号，中日文沿用全角，避免英文界面出现全角标点
    colon() {
      return this.$i18n.locale === "en" ? ": " : "：";
    },
    currentFormItem() {
      return this.formItem;
    },
    // rules 转 computed：校验消息随语言热切换
    rules() {
      return {
        projectName: [
          {
            required: true,
            message: this.$t("account.project_name_required"),
            trigger: ["blur", "change"],
          },
        ],
      };
    },
  },
  watch: {
    '$i18n.locale'() {
      // 保留输入，仅清理旧语言的校验提示
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
    },
    show: {
      handler(val) {
        if (val) {
          this.form = { ...this.rowInfo };
          console.log(this.rowInfo, "vvvv");
        }
      },
      deep: true,
    },
  },
  methods: {
    handleClose(done) {
      // this.$emit("toggleShow", false);
      this.$emit("update:show", false);
    },
    handleSubmit() {
      //   this.$emit("submit");
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // alert('submit!');
          let params = {
            projectId: this.rowInfo.projectId,
            projectName: this.form.projectName,
          }
          updateProjectName(params).then(res=>{
            if(res.code == 200){
                this.$message.success(res.msg)
                this.handleClose()
                this.$emit("refush");
            }
          })
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  justify-content: center;
  .btn {
    width: 180px;
    height: 32px;
  }
}
.form {
  justify-content: center;
}
</style>